export default __webpack_public_path__ + "static/media/why oifend.9e6d1a64.svg";